import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-dark-bg/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
            <img
              src="https://public.readdy.ai/ai/img_res/5bc5f722-4c51-4a16-b952-a25cd81fdf88.png"
              alt="PLADUREX Logo"
              className="h-10 sm:h-12 w-auto"
            />
            <span className="text-text-primary text-xl sm:text-2xl font-bold">PLADUREX</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="relative text-text-primary hover:text-orange-primary transition-colors duration-300 text-[15px] font-medium group whitespace-nowrap"
              >
                {link.label}
                <span
                  className={`absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 bg-orange-primary transition-all duration-300 ${
                    location.pathname === link.path
                      ? 'w-full'
                      : 'w-0 group-hover:w-full'
                  }`}
                ></span>
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4 flex-shrink-0">
            <a
              href="tel:+34629501941"
              className="px-5 py-2.5 border-2 border-orange-primary text-orange-primary rounded-full hover:bg-orange-primary hover:text-white transition-all duration-300 text-[15px] font-medium whitespace-nowrap flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Llamar</span>
            </a>
            <a
              href="https://wa.me/34629501941"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-orange-primary text-white rounded-full hover:shadow-glow-orange transition-all duration-300 text-[15px] font-medium whitespace-nowrap flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-text-primary text-2xl w-10 h-10 flex items-center justify-center flex-shrink-0"
            aria-label="Menú"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="lg:hidden bg-dark-bg/98 backdrop-blur-md border-t border-dark-border"
        >
          <nav className="px-4 sm:px-6 py-6 space-y-4 max-w-7xl mx-auto">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-text-primary hover:text-orange-primary transition-colors duration-300 text-base font-medium ${
                  location.pathname === link.path ? 'text-orange-primary' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 space-y-3">
              <a
                href="tel:+34629501941"
                className="block w-full px-5 py-3 border-2 border-orange-primary text-orange-primary rounded-full hover:bg-orange-primary hover:text-white transition-all duration-300 text-center font-medium whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Llamar
              </a>
              <a
                href="https://wa.me/34629501941"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-5 py-3 bg-orange-primary text-white rounded-full hover:shadow-glow-orange transition-all duration-300 text-center font-medium whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </a>
            </div>
          </nav>
        </motion.div>
      )}
    </header>
  );
};

export default Header;
